import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Grid, Container, Button, Segment } from 'semantic-ui-react';
import { injectIntl } from 'react-intl';
import about from '../About';
import config from '../config';
import Footer from './Footer';
import { login } from 'src/api';
import OnPremLoginForm from './OnPremLoginForm';

function LoginPanel(props) {
  const onPrem = window.runtime.onPremDist ?? false;
  const { loggedIn } = useSelector((state) => state.mainFrame);
  const [params, _] = useSearchParams();
  const afc = params.get('afc');
  const [loginError, setLoginError] = useState(false);

  useEffect(() => {
    login().catch((err) => {
      setLoginError(true);
    });
  }, []);

  if (loggedIn) {
    if (afc) {
      return <Navigate to="/afc" />;
    } else {
      return <Navigate to="/projects" />;
    }
  }

  return (
    <>
      <img src="/assets/login_banner.png" alt="Network image" width="100%" />
      <Container
        style={{
          position: 'fixed',
          bottom: '0',
          left: '0',
          width: '100%',
        }}
      >
        <Container>
          <Grid
            columns={2}
            stackable
            celled="internally"
            relaxed="very"
            padded="vertically"
          >
            <Grid.Row
              verticalAlign="middle"
              style={{ backgroundColor: '#f9f9f9' }}
            >
              <Grid.Column>
                <Segment vertical size="large">
                  <p>
                    LINKPlanner allows you to model "what if" scenarios - based
                    on geography, distance, antenna height, transmit power, and
                    other factors – to optimize system performance before
                    purchase. Quickly design networks using Airspan
                    family of products, for optimal deployment and cost
                    effectiveness with ease.
                  </p>
                  <p>
                    LINKPlanner is a free, user-friendly link-design tool.
                    LINKPlanner leads the industry as the most trusted and
                    intuitive RF link planning tool, with tens of thousands of
                    links deployed successfully worldwide.
                  </p>
                </Segment>
                <Segment vertical size="large">
                  If you have any questions about the LINKPlanner or for
                  additional support please contact{' '}
                  {/* note that we have to hard-code the email address in here */}
                  <a href={`mailto:${about.email}`}>{about.email}</a>.
                </Segment>

              </Grid.Column>

              <Grid.Column textAlign="center">
                {loginError && (
                  <Segment inverted color="red">
                    Error connecting with server. Please refresh and try again.
                    <br />
                    If the problem persists, please contact{' '}
                    <a
                      href={`mailto:${about.email}`}
                      style={{ color: 'white', textDecoration: 'underline' }}
                    >
                      {about.email}
                    </a>
                    .
                  </Segment>
                )}

                {onPrem && <OnPremLoginForm />}
                {!onPrem && (
                  <Button primary as="a" href={`${config.apiURL}/saml/login`}>
                    Sign In
                  </Button>
                )}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={1}>
              <Grid.Column>
                <Footer></Footer>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Container>
    </>
  );
}

export default injectIntl(LoginPanel);
